<template>
  <div class="app-floating-actions-host">
    <div
      v-show="!hidden"
      class="app-floating-actions"
      aria-label="快捷操作"
    >
      <button class="app-floating-actions__button" type="button" aria-label="联系我们" @click="openContact">
        <img
          class="app-floating-actions__contact-icon"
          src="@/assets/pages/home/images/ffe0d7af84eb567a6ed39286058b8a29.png"
          alt=""
        />
      </button>
      <button class="app-floating-actions__button" type="button" aria-label="返回顶部" @click="backToTop">
        <img
          class="app-floating-actions__back-to-top-icon"
          src="@/assets/pages/home/images/0db8c927597f308d0bca8a5f4e8b827e.png"
          alt=""
        />
      </button>
    </div>

    <contact-dialog v-model="isContactDialogOpen" />
  </div>
</template>

<script>
import ContactDialog from '@/components/contact/ContactDialog.vue'

export default {
  name: 'AppFloatingActions',
  components: {
    ContactDialog
  },
  props: {
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isContactDialogOpen: false
    }
  },
  methods: {
    openContact() {
      this.isContactDialogOpen = true
    },
    backToTop() {
      this.$emit('back-to-top')

      if (!this.$listeners['back-to-top']) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.app-floating-actions {
  position: fixed;
  right: max(12px, env(safe-area-inset-right));
  bottom: calc(env(safe-area-inset-bottom) + 94px);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.app-floating-actions__button {
  display: flex;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.app-floating-actions__contact-icon {
  width: 21px;
  height: 17px;
  object-fit: contain;
}

.app-floating-actions__back-to-top-icon {
  width: 13px;
  height: 16px;
  object-fit: contain;
}
</style>
